module.exports = __webpack_public_path__ + "static_1727318417925/img/giftList.a7420431.jpg";